const BASE_URL =
  import.meta.env.VITE_API_BASE_URL ||
  "http://localhost:5002";

export default BASE_URL;

const API_VERSION = "v1";
const API_BASE = `${BASE_URL}/api/${API_VERSION}`;

export const API_ENDPOINTS = {
  faqs: API_BASE + "/faqs",
  chatbotAsk: API_BASE + "/chatbot/ask",
  chatbotLanding: API_BASE + "/chatbot/landing",
  chatbotCities: API_BASE + "/chatbot/cities",
  chatbotFeedback: API_BASE + "/chatbot/feedback",
  publicFaqs: API_BASE + "/public/faqs",
  publicChatAsk: API_BASE + "/public/chat/ask",
  publicLeadUpsert: API_BASE + "/public/leads/upsert",
  publicLeadAction: API_BASE + "/public/leads/action",
  brochureInfo: API_BASE + "/brochure/info",
  brochureDownload: API_BASE + "/brochure/download",
  superadminPublicLeads: API_BASE + "/superadmin/public-leads",
  superadminPublicLead: (id) => `${API_BASE}/superadmin/public-leads/${id}`,
  publicDemoSlots: (date) => `${API_BASE}/public/demo-bookings/slots?date=${date}`,
  publicDemoBook: API_BASE + "/public/demo-bookings",
  superadminDemoBookings: API_BASE + "/superadmin/demo-bookings",
  superadminDemoBooking: (id) => `${API_BASE}/superadmin/demo-bookings/${id}`,
  authRefreshToken: `${API_BASE}/auth/refresh-token`,
  authLogin: API_BASE + "/auth/login",

  users: API_BASE + "/users",
  usersCreate: API_BASE + "/users/create",
  usersByRole: (role) => `${API_BASE}/users?role=${role}`,
  usersTeachers: API_BASE + "/users/teachers",
  usersStaff: API_BASE + "/users/staff",
  usersTeachersByYear: (year) => `${API_BASE}/users/teachers?academicYear=${year}`,
  usersStudents: API_BASE + "/users/students",
  usersStudentsByYear: (year) => `${API_BASE}/users/students?academicYear=${year}`,
  usersAcademicYear: API_BASE + "/users/academic-year",
  usersImport: API_BASE + "/users/import-users",
  usersPendingEmails: (params) => `${API_BASE}/users/pending-emails${params ? "?" + params : ""}`,
  usersSendBatchEmails: API_BASE + "/users/send-batch-emails",
  user: (id) => `${API_BASE}/users/${id}`,
  userTeachersTransition: API_BASE + "/users/teachers/transition",
  userStudentsTransition: API_BASE + "/users/students/transition",

  classes: API_BASE + "/classes",
  class: (id) => `${API_BASE}/classes/${id}`,
  sections: API_BASE + "/sections",
  sectionsByClass: (classId) => `${API_BASE}/sections/class/${classId}`,
  section: (id) => `${API_BASE}/sections/${id}`,
  academicYears: API_BASE + "/academic-years",
  academicYear: (id) => `${API_BASE}/academic-years/${id}`,

  subjects: API_BASE + "/subjects",
  subject: (id) => `${API_BASE}/subjects/${id}`,
  workShifts: API_BASE + "/work-shifts",
  workShift: (id) => `${API_BASE}/work-shifts/${id}`,
  shiftAssignments: API_BASE + "/shift-assignments",
  shiftAssignment: (id) => `${API_BASE}/shift-assignments/${id}`,
  wings: API_BASE + "/wings",
  wing: (id) => `${API_BASE}/wings/${id}`,
  departments: API_BASE + "/departments",
  department: (id) => `${API_BASE}/departments/${id}`,



  vehicles: API_BASE + "/vehicles",
  vehicle: (id) => `${API_BASE}/vehicles/${id}`,
  vehicleChangePassword: (id) => `${API_BASE}/vehicles/${id}/change-password`,
  drivers: API_BASE + "/drivers",
  fuelEntries: API_BASE + "/fuel-entries",
  fuelEntry: (id) => `${API_BASE}/fuel-entries/${id}`,
  fuelStats: API_BASE + "/fuel-entries/stats",
  fuelExportPDF: API_BASE + "/fuel-entries/export/pdf",
  vehicleRoutes: API_BASE + "/vehicle-routes",
  vehicleRoute: (id) => `${API_BASE}/vehicle-routes/${id}`,
  vehicleRoutesBySchool: (schoolId) => `${API_BASE}/vehicle-routes/school/${schoolId}`,
  vehicleRouteStudent: (studentId) => `${API_BASE}/vehicle-routes/student/${studentId}`,
  vehicleRouteMappingsFlat: API_BASE + "/vehicle-routes/mappings/all/flat",
  vehicleRouteMappingsGrouped: API_BASE + "/vehicle-routes/mappings/all/grouped",
  vehicleRouteMappingsStop: (routeId, shiftId, stopId) =>
    `${API_BASE}/vehicle-routes/mappings/stop/${routeId}/${shiftId}/${stopId}`,
  vehicleRouteMappingsStudent: (studentId) =>
    `${API_BASE}/vehicle-routes/mappings/student/${studentId}/details`,
  vehicleRouteMappingsStats: API_BASE + "/vehicle-routes/mappings/statistics/summary",
  vehicleRouteMappingsImport: API_BASE + "/vehicle-routes/mappings/import",
  vehiclesStartLocation: API_BASE + "/vehicles/start-location",
  vehiclesEndLocation: API_BASE + "/vehicles/end-location",

  attendanceBusStop: API_BASE + "/attendance/bus-stop",
  attendanceBusStopHistory: API_BASE + "/attendance/bus-stop-history",
  teacherAttendance: API_BASE + "/teacher-attendance",
  teacherAttendanceByDate: (date) => `${API_BASE}/teacher-attendance?date=${date}`,
  staffAttendanceByDate: (date) => `${API_BASE}/teacher-attendance?date=${date}&type=staff`,
  teacherAttendanceMark: API_BASE + "/teacher-attendance/mark",
  teacherAttendanceMonthlySummary:
    API_BASE + "/teacher-attendance/teacher-attendance/monthly-summary",

  leave: API_BASE + "/leave",
  leaveTeacher: API_BASE + "/leave/teacher",
  leaveStaff: API_BASE + "/leave/staff",
  leaveById: (id) => `${API_BASE}/leave/${id}`,
  leaveTypes: API_BASE + "/leave-types",
  leaveType: (id) => `${API_BASE}/leave-types/${id}`,
  teacherSalaryConfigs: API_BASE + "/teacher-salary/configs",
  teacherSalaryConfig: (id) => `${API_BASE}/teacher-salary/configs/${id}`,
  teacherSalaryWorkingDays: (month, year) => `${API_BASE}/teacher-salary/working-days?month=${month}&year=${year}`,
  teacherSalaryCalculate: (month, year, teacherId) => `${API_BASE}/teacher-salary/calculate?month=${month}&year=${year}${teacherId ? `&teacherId=${teacherId}` : ""}`,
  teacherSalarySlips: (params) => `${API_BASE}/teacher-salary/slips${params ? `?${params}` : ""}`,
  teacherSalarySlipById: (id) => `${API_BASE}/teacher-salary/slips/${id}`,
  teacherSalarySlipStatus: (id) => `${API_BASE}/teacher-salary/slips/${id}/status`,
  teacherSalarySlipsExcel: (month, year) => `${API_BASE}/teacher-salary/slips/excel?month=${month}&year=${year}`,
  teacherSalarySummary: (month, year) => `${API_BASE}/teacher-salary/slips/summary${month && year ? `?month=${month}&year=${year}` : ""}`,
  allowanceDeductionHeads: API_BASE + "/allowance-deduction-heads",
  allowanceDeductionHead: (id) => `${API_BASE}/allowance-deduction-heads/${id}`,
  leaveBalance: (params) => `${API_BASE}/leave-balance${params ? `?${params}` : ""}`,
  teacherSalarySlipDownload: (id) => `${API_BASE}/teacher-salary/slips/${id}/download`,
  staffSalaryConfigs: API_BASE + "/staff-salary/configs",
  staffSalaryConfig: (id) => `${API_BASE}/staff-salary/configs/${id}`,
  staffSalaryWorkingDays: (month, year) => `${API_BASE}/staff-salary/working-days?month=${month}&year=${year}`,
  staffSalaryCalculate: (month, year, staffId) => `${API_BASE}/staff-salary/calculate?month=${month}&year=${year}${staffId ? `&staffId=${staffId}` : ""}`,
  staffSalarySlips: (params) => `${API_BASE}/staff-salary/slips${params ? `?${params}` : ""}`,
  staffSalarySlipById: (id) => `${API_BASE}/staff-salary/slips/${id}`,
  staffSalarySlipStatus: (id) => `${API_BASE}/staff-salary/slips/${id}/status`,
  staffSalarySlipsExcel: (month, year) => `${API_BASE}/staff-salary/slips/excel?month=${month}&year=${year}`,
  staffSalarySummary: (month, year) => `${API_BASE}/staff-salary/slips/summary${month && year ? `?month=${month}&year=${year}` : ""}`,
  staffSalarySlipDownload: (id) => `${API_BASE}/staff-salary/slips/${id}/download`,

  schoolAbout: API_BASE + "/schools/about-school",
  schoolSettings: (schoolId) => `${API_BASE}/schools/${schoolId}/settings`,
  schoolAllowedPermissions: (schoolId) => `${API_BASE}/schools/${schoolId}/allowed-permissions`,
  schoolUploadReceiptStamp: API_BASE + "/schools/upload-receipt-stamp",
  schoolUploadReceiptSignature: API_BASE + "/schools/upload-receipt-signature",
  schoolForceLogoutAll: (schoolId) => `${API_BASE}/schools/${schoolId}/force-logout-all`,

  // Feature Management Endpoints
  schoolFeatures: (schoolId) => `${API_BASE}/schools/${schoolId}/features`,
  schoolFeaturesAvailable: API_BASE + "/schools/features/available",
  schoolFeaturesBulk: (schoolId) => `${API_BASE}/schools/${schoolId}/features/bulk`,
  schoolFeatureToggle: (schoolId, featureKey) => `${API_BASE}/schools/${schoolId}/features/${featureKey}/toggle`,
  schoolFeaturesReset: (schoolId) => `${API_BASE}/schools/${schoolId}/features/reset`,
  schoolFeatureStatus: (schoolId, featureKey) => `${API_BASE}/schools/${schoolId}/features/${featureKey}/status`,



  feesStudent: (studentId) => `${API_BASE}/fees/student/${studentId}`,
  feesHistory: API_BASE + "/fees/fee-history",
  feesStudentStatus: (feeId) => `${API_BASE}/fees/student-fees/${feeId}/status`,
  feesWaiveLateFee: (feeId) => `${API_BASE}/fees/student-fees/${feeId}/waive-late-fee`,

  sectionSubjects: API_BASE + "/section-subjects",
  studentSubjects: (studentId) => `${API_BASE}/student-subjects?studentId=${studentId}`,
  studentSubjectDrop: (id) => `${API_BASE}/student-subjects/${id}/drop`,
  studentSubjectRestore: (id) => `${API_BASE}/student-subjects/${id}/restore`,
  studentSubjectsSync: API_BASE + "/student-subjects/sync",

  classroomMappingsImportTemplate: API_BASE + "/classroom-mappings/import/template",
  classroomMappingsImportValidate: API_BASE + "/classroom-mappings/import/validate",
  classroomMappingsImportConfirm: API_BASE + "/classroom-mappings/import/confirm",
  classroomMappingsImportTemplateDownload: API_BASE + "/classroom-mappings/import/template/download",

  room: (id) => `${API_BASE}/rooms/${id}`,

  lateFeesGet: API_BASE + "/late-fees/get",
  lateFeesUpdateSettings: API_BASE + "/late-fees/update-settings",
  lateFeeCalculationType: (schoolId) => `${API_BASE}/late-fees/schools/${schoolId}/calculation-type`,

  adminAccess: API_BASE + "/admin-access",
  adminAccessCreate: API_BASE + "/admin-access/create",
  adminAccessById: (id) => `${API_BASE}/admin-access/${id}`,
  adminAccessPermissions: (adminId) => `${API_BASE}/admin-access/${adminId}/permissions`,
  teacherAccessPermissions: (teacherId) => `${API_BASE}/teacher-access/${teacherId}/permissions`,

  schoolRoles: API_BASE + "/school-roles",
  schoolRole: (id) => `${API_BASE}/school-roles/${id}`,
  permissionsList: API_BASE + "/school-roles/permissions",

  faceRecognition: API_BASE + "/face-recognition",
  faceMatch: API_BASE + "/face-recognition/match",
  faceRegistered: API_BASE + "/face-recognition/registered",
  faceDelete: (userId) => `${API_BASE}/face-recognition/${userId}`,
  biometricEnrollments: API_BASE + "/biometric/enrollments",
  biometricEnrollment: (id) => `${API_BASE}/biometric/enrollments/${id}`,


  vehicleRouteShifts: (routeId) => API_BASE + "/vehicle-routes/" + routeId + "/shifts",
  vehicleRouteShift: (routeId, shiftId) =>
    API_BASE + "/vehicle-routes/" + routeId + "/shifts/" + shiftId,
  vehicleRouteShiftStops: (routeId, shiftId) =>
    API_BASE + "/vehicle-routes/" + routeId + "/shifts/" + shiftId + "/stops",
  vehicleRouteShiftStop: (routeId, shiftId, stopId) =>
    API_BASE + "/vehicle-routes/" + routeId + "/shifts/" + shiftId + "/stops/" + stopId,
  vehicleRouteStopsOrder: (routeId, shiftId) =>
    API_BASE + "/vehicle-routes/" + routeId + "/shifts/" + shiftId + "/stops/order",
  vehicleRoutesSchoolStudents: (schoolId) =>
    API_BASE + "/vehicle-routes/school/" + schoolId + "/students",
  vehiclesBySchool: (schoolId) => API_BASE + "/vehicles?schoolId=" + schoolId,

  vendors: API_BASE + "/vendors",
  vendorSummary: API_BASE + "/vendors/summary",
  vendorLedgerSummary: API_BASE + "/vendors/ledger-summary",
  vendorsExpiringContracts: API_BASE + "/vendors/expiring-contracts",
  vendor: (id) => `${API_BASE}/vendors/${id}`,
  vendorProducts: (id) => `${API_BASE}/vendors/${id}/products`,
  vendorTransactions: (id) => `${API_BASE}/vendors/${id}/transactions`,
  vendorBillingSlip: (id) => `${API_BASE}/vendors/${id}/billing-slip`,

  inventory: API_BASE + "/inventory",
  inventoryUiConfig: API_BASE + "/inventory-ui-config",
  inventoryItem: (id) => `${API_BASE}/inventory/${id}`,
  inventoryImportTemplate: API_BASE + "/inventory/import/template",
  inventoryImportValidate: API_BASE + "/inventory/import/validate",
  inventoryImportResolve: API_BASE + "/inventory/import/resolve",
  inventoryImportConfirm: API_BASE + "/inventory/import/confirm",
  inventoryExport: API_BASE + "/inventory/export",
  inventoryPurchase: (id) => `${API_BASE}/inventory/${id}/purchase`,
  inventoryIssue: (id) => `${API_BASE}/inventory/${id}/issue`,
  inventoryHold: (id) => `${API_BASE}/inventory/${id}/hold`,
  inventoryUnhold: (id) => `${API_BASE}/inventory/${id}/unhold`,
  inventoryAdjust: (id) => `${API_BASE}/inventory/${id}/adjust`,
  inventoryIssueTodayStats: API_BASE + "/inventory/issue-today-stats",
  inventoryPurchaseTodayStats: API_BASE + "/inventory/purchase-today-stats",
  inventoryBulkIssue: API_BASE + "/inventory/bulk-issue",
  inventoryBulkPurchase: API_BASE + "/inventory/bulk-purchase",
  inventoryDemandRequests: API_BASE + "/inventory/demand-requests",
  inventoryDemandRequest: (id) => `${API_BASE}/inventory/demand-requests/${id}`,
  inventoryReorderAlerts: API_BASE + "/inventory/reorder-alerts",
  inventoryNonMoving: API_BASE + "/inventory/non-moving",
  inventoryTransactions: API_BASE + "/inventory/transactions",
  inventoryTransactionUndo: (id) => `${API_BASE}/inventory/transactions/${id}/undo`,
  inventoryTransactionReturn: (id) => `${API_BASE}/inventory/transactions/${id}/return`,
  inventoryItemParties: (id) => `${API_BASE}/inventory/${id}/parties`,
  inventoryReturnToParty: (id) => `${API_BASE}/inventory/${id}/return-to-party`,
  inventoryTransactionsSummary: (schoolId, range) =>
    `${API_BASE}/inventory/transactions/summary?schoolId=${schoolId}&range=${range}`,
  inventoryAnalyticsDashboard: API_BASE + "/inventory/analytics/dashboard",
  inventoryAnalyticsAnalysis: API_BASE + "/inventory/analytics/analysis",
  inventoryCategories: API_BASE + "/inventory-categories",
  inventoryCategory: (id) => `${API_BASE}/inventory-categories/${id}`,
  inventorySubCategories: API_BASE + "/inventory-sub-categories",
  inventorySubCategory: (id) => `${API_BASE}/inventory-sub-categories/${id}`,
  inventoryUnits: API_BASE + "/inventory-units",
  inventoryUnit: (id) => `${API_BASE}/inventory-units/${id}`,
  inventorySizes: API_BASE + "/inventory-sizes",
  inventorySize: (id) => `${API_BASE}/inventory-sizes/${id}`,
  inventoryBrands: API_BASE + "/inventory-brands",
  inventoryBrand: (id) => `${API_BASE}/inventory-brands/${id}`,
  inventoryColors: API_BASE + "/inventory-colors",
  inventoryColor: (id) => `${API_BASE}/inventory-colors/${id}`,
  inventoryFeatureConfig: API_BASE + "/inventory-feature-config",

  customers: API_BASE + "/customers",
  customer: (id) => `${API_BASE}/customers/${id}`,
  customerLedger: (id) => `${API_BASE}/customers/${id}/ledger`,
  customerLedgerSummary: API_BASE + "/customers/ledger-summary",
  customerPaymentLogs: (id) => `${API_BASE}/customers/${id}/payment-logs`,
  ledger: API_BASE + "/ledger",
  ledgerPayment: (id) => `${API_BASE}/ledger/${id}/payment`,

  assets: API_BASE + "/assets",
  asset: (id) => `${API_BASE}/assets/${id}`,
  assetMaintenance: (id) => `${API_BASE}/assets/${id}/maintenance`,


  holidays: API_BASE + "/holidays",
  holidaysAdd: API_BASE + "/holidays/add",
  holidaysBulkAdd: API_BASE + "/holidays/bulk-add",
  holiday: (id) => `${API_BASE}/holidays/${id}`,
  holidaysUpdateConfig: API_BASE + "/holidays/update-config",

  classroomMappingsByClass: (classId, academicYear) =>
    `${API_BASE}/classroom-mappings/class/${classId}?academicYear=${academicYear}`,
  classroomMappings: API_BASE + "/classroom-mappings",
  classroomMappingsUser: (userId) => `${API_BASE}/classroom-mappings/user/${userId}`,
  classroomMappingsBulkAssign: API_BASE + "/classroom-mappings/bulk-assign",
  classroomMapping: (mappingId, userType) =>
    `${API_BASE}/classroom-mappings/${mappingId}?userType=${userType}`,

  driversStats: API_BASE + "/drivers/stats",
  driverById: (id) => `${API_BASE}/drivers/${id}`,

  announcementsAdmin: API_BASE + "/announcements/admin",
  announcement: (id) => `${API_BASE}/announcements/${id}`,
  announcements: API_BASE + "/announcements",

  notificationsSettings: API_BASE + "/notifications/settings",

  feesStudentsAll: API_BASE + "/fees/students/all-with-fees",
  feesSendNotifications: API_BASE + "/fees/send-notifications",
  fees: API_BASE + "/fees",
  fee: (id) => `${API_BASE}/fees/${id}`,
  feesByClass: (classId, academicYear) =>
    `${API_BASE}/fees/class/${classId}${academicYear ? `?academic_year=${academicYear}` : ""}`,
  feesSchedules: API_BASE + "/fees/schedules",
  feesMakeLive: API_BASE + "/fees/make-live",

  scholarships: API_BASE + "/scholarships",
  scholarship: (id) => `${API_BASE}/scholarships/${id}`,
  scholarshipsBySchool: (schoolId) => `${API_BASE}/scholarships?schoolId=${schoolId}`,
  scholarshipsAssigned: (schoolId) => `${API_BASE}/scholarships/assigned?schoolId=${schoolId}`,
  scholarshipsAssign: API_BASE + "/scholarships/assign",

  lateFeesSlab: (id) => `${API_BASE}/late-fees/slabs/${id}`,
  lateFeesSlabs: API_BASE + "/late-fees/slabs",
  lateFeeConfig: (classId, quarter) =>
    `${API_BASE}/late-fee-configs/${classId}/${quarter}`,
  lateFeeConfigsBulk: API_BASE + "/late-fee-configs/bulk",
  lateFeeConfigs: API_BASE + "/late-fee-configs",

  busFeesTypes: API_BASE + "/bus-fees/types",
  busFeesType: (id) => `${API_BASE}/bus-fees/types/${id}`,
  busFeesMultiplier: API_BASE + "/bus-fees/multiplier",
  busFeesLink: API_BASE + "/bus-fees/link",

  vehicleRouteLastStop: (routeId) =>
    `${API_BASE}/vehicle-routes/${routeId}/last-stop-location`,

  academicYearsCurrent: API_BASE + "/academic-years/current",

  classesSchool: (schoolId) => `${API_BASE}/classes/school/${schoolId}`,

  usersProfile: API_BASE + "/users/profile",

  vehiclesProfile: API_BASE + "/vehicles/profile",
  vehicleRoutesCalculateEta: API_BASE + "/vehicle-routes/calculate-eta",



  notifications: (limit) =>
    `${API_BASE}/notifications${limit ? `?limit=${limit}` : ""}`,
  notificationsMarkRead: API_BASE + "/notifications/mark-read",

  authForgotPassword: API_BASE + "/auth/forgot-password",
  authVerifyAdditionalDetails: API_BASE + "/auth/verify-additional-details",
  authVerifyOtp: API_BASE + "/auth/verify-otp",
  authResetPassword: API_BASE + "/auth/reset-password",
  authLogout: API_BASE + "/auth/logout",

  leaveApplicationsStudent: API_BASE + "/leave-applications/student",
  leaveApplications: API_BASE + "/leave-applications",
  leaveApplication: (id) => `${API_BASE}/leave-applications/${id}`,

  scholarshipsStudent: (studentId, schoolId) =>
    `${API_BASE}/scholarships/student/${studentId}?schoolId=${schoolId}`,

  feesLateFee: (feeId) => `${API_BASE}/fees/late-fee/${feeId}`,
  feesStudentFees: (studentId) =>
    `${API_BASE}/fees/student/fees?studentId=${studentId}`,
  feesStudentQuarterly: (studentId) =>
    `${API_BASE}/fees/student/quarterly?studentId=${studentId}`,
  feesStudentHistory: API_BASE + "/fees/student/history",
  feesRazorpayCreateOrder: API_BASE + "/fees/razorpay/create-order",
  feesRazorpayVerifyPayment: API_BASE + "/fees/razorpay/verify-payment",
  feesRazorpaySchoolRoute: API_BASE + "/fees/razorpay/school-route",
  feesPayQuarterly: API_BASE + "/fees/pay-quarterly",

  schools: API_BASE + "/schools",
  school: (id) => `${API_BASE}/schools/${id}`,
  schoolsStats: API_BASE + "/schools/stats",
  schoolGroups: API_BASE + "/schools/groups",

  superSchoolAdmins: API_BASE + "/super-school-admins",

  usersStats: API_BASE + "/users/stats",

  busTrackingVehicle: (vehicleId) =>
    `${API_BASE}/bus-tracking/vehicle/${vehicleId}`,
  busTrackingHistory: (params) =>
    `${API_BASE}/bus-tracking/history${params ? `?${params}` : ""}`,

  logsErrors: (params) =>
    `${API_BASE}/logs/errors${params ? `?${params}` : ""}`,
  logsFailures: (params) =>
    `${API_BASE}/logs/failures${params ? `?${params}` : ""}`,
  logsRequests: (params) =>
    `${API_BASE}/logs/requests${params ? `?${params}` : ""}`,
  logsStats: API_BASE + "/logs/stats",
  logsAppVersions: API_BASE + "/logs/app-versions",
  logsTrends: (params) =>
    `${API_BASE}/logs/trends${params ? `?${params}` : ""}`,

  appConfig: API_BASE + "/app/config",
  appConfigHistory: (params) => `${API_BASE}/app/config/history${params ? `?${params}` : ""}`,

  dashboardStats: API_BASE + "/dashboard/stats",

  teacherAttendanceClockIn: API_BASE + "/teacher-attendance/clock-in",

  classroomMappingsClass: (classId) =>
    `${API_BASE}/classroom-mappings/class/${classId}`,
  classroomMappingsStudentsUnassigned: (classId) =>
    `${API_BASE}/classroom-mappings/students/unassigned?classId=${classId}`,

  leaveApplicationsTeacher: API_BASE + "/leave-applications/teacher",
  leaveApplicationApprove: (id) =>
    `${API_BASE}/leave-applications/${id}/approve`,
  leaveApplicationReject: (id) =>
    `${API_BASE}/leave-applications/${id}/reject`,

  transcribeAudio: API_BASE + "/transcribe-audio",

  paymentMethods: API_BASE + "/payment-methods",
  paymentMethod: (id) => `${API_BASE}/payment-methods/${id}`,
  paymentMethodsActive: API_BASE + "/payment-methods/active",
  designations: API_BASE + "/designations",
  designation: (id) => `${API_BASE}/designations/${id}`,

  pageVisits: API_BASE + "/page-visits",
  pageVisitStats: API_BASE + "/page-visits/stats",
  pageVisitSchools: API_BASE + "/page-visits/schools",
  buttonClickStats: API_BASE + "/button-clicks/stats",

  publicBlogs: API_BASE + "/public/blogs",
  publicBlog: (slug) => `${API_BASE}/public/blogs/${slug}`,
  publicBlogLike: (slug) => `${API_BASE}/public/blogs/${slug}/like`,
  publicBlogUnlike: (slug) => `${API_BASE}/public/blogs/${slug}/unlike`,
  publicBlogComments: (slug) => `${API_BASE}/public/blogs/${slug}/comments`,
  superadminBlogs: API_BASE + "/superadmin/blogs",
  superadminBlog: (id) => `${API_BASE}/superadmin/blogs/${id}`,
  superadminBlogImageUpload: API_BASE + "/superadmin/blogs/upload-image",

  // Billing (Super Admin)
  billingPlans: API_BASE + "/billing/plans",
  billingPlan: (planId) => `${API_BASE}/billing/plans/${planId}`,
  billingPlanDisable: (planId) => `${API_BASE}/billing/plans/${planId}/disable`,
  billingSubscription: (schoolId) => `${API_BASE}/billing/schools/${schoolId}/subscription`,
  billingSubscriptions: (schoolId) => `${API_BASE}/billing/schools/${schoolId}/subscriptions`,
  billingSubscriptionTrial: (schoolId) => `${API_BASE}/billing/schools/${schoolId}/subscription/trial`,
  billingSubscriptionTrialEndDate: (schoolId) => `${API_BASE}/billing/schools/${schoolId}/subscription/trial/end-date`,
  billingSubscriptionUserLimit: (schoolId) => `${API_BASE}/billing/schools/${schoolId}/subscription/user-limit`,
  billingPayments: (schoolId) => `${API_BASE}/billing/schools/${schoolId}/payments`,
  billingPaymentsManual: (schoolId) => `${API_BASE}/billing/schools/${schoolId}/payments/manual`,
  billingInvoices: (schoolId) => `${API_BASE}/billing/schools/${schoolId}/invoices`,
  billingEntitlement: (schoolId) => `${API_BASE}/billing/schools/${schoolId}/entitlement/user`,
  billingAuditLog: (schoolId) => `${API_BASE}/billing/schools/${schoolId}/audit-log`,
  billingRefunds: (schoolId) => `${API_BASE}/billing/schools/${schoolId}/refunds`,
  billingPaymentRefund: (schoolId, paymentId) => `${API_BASE}/billing/schools/${schoolId}/payments/${paymentId}/refund`,
  billingDiscounts: (schoolId) => `${API_BASE}/billing/schools/${schoolId}/discounts`,
  billingDiscountRemove: (schoolId, planId) => `${API_BASE}/billing/schools/${schoolId}/discounts/${planId}`,

  // Billing (tenant self-service)
  billingMyOverview: API_BASE + "/billing/me/overview",
  billingMyAccessStatus: API_BASE + "/billing/me/access-status",
  billingMyPayments: API_BASE + "/billing/me/payments",
  billingMyPlans: API_BASE + "/billing/me/plans",
  billingMyInvoices: API_BASE + "/billing/me/invoices",
  billingMyOrders: API_BASE + "/billing/me/orders",
  billingMyNudgeShown: API_BASE + "/billing/me/nudge-shown",
};
